<template>
  <HomeLayout>
    <md-scroll-view
      ref="scrollView"
      :scrolling-x="false"
      :is-prevent="false"
      :auto-reflow="autoReflow"
      :bouncing="false"
      :end-reached-threshold="300"
      @end-reached="handleLoadMore"
    >
      <div class="home-page">
        <div class="home-block">
          <template v-if="isActive">
            <h2 class="amount-title">{{ $t('cannot_amount') }}</h2>

            <div
              :class="[
                'home-amount',
                { large: `${model.balance}`.length >= 7 },
              ]"
            >
              <!-- <md-amount
                v-if="model.balance !== symbol"
                :value="model.balance | fenToYanAndFormat"
                has-separator
              /> -->
              <span v-if="model.balance !== symbol">
                {{ model.balance | fenToYanAndFormat }}
              </span>
              <span v-else>
                {{ model.balance }}
              </span>
            </div>

            <ActionList />
          </template>

          <!-- 去激活 -->
          <div v-else class="activated-info">
            <h2 class="title">{{ $t("beActivated") }}</h2>
            <div class="sub-title">
              <!-- {{ $t('ageLimit') }} -->
              <!-- <span class="sub-title-span">{{ $t("activate_get_baht") }}</span>
              <img :src="require('@/assets/hot.png')"> -->
            </div>

            <md-button type="primary" size="lg" @click="handleToActivate">
              {{ $t("activate") }}
            </md-button>
          </div>
        </div>

        <ActionList v-if="!isActive" is-block />

        <div class="order-list-title">
          <h2>{{ $t("transactions") }}</h2>
          <md-button
            type="link"
            :style="{ color: '#7f7f7f' }"
            @click="$router.push({ name: 'TransactionRecord' })"
          >
            {{ $t("viewAll") }}
          </md-button>
        </div>

        <OrderList :is-empty="total === 0">
          <OrderItem
            v-for="(item, index) in tradeList"
            :key="index"
            :model="item"
          />
        </OrderList>
      </div>
      <AcitvateResult
        v-model="isShow"
        :level-type="+$route.params.level"
        :amount-data="totalityLimitAmountData"
      />
      <md-scroll-view-more
        v-if="total !== 0"
        :is-finished="tradeList.length >= total"
        :finished-text="$t('finished_text')"
        :loading-text="$t('loading_text')"
      />
    </md-scroll-view>
  </HomeLayout>
</template>

<script>
import OrderItem from '@/components/OrderItem'
import OrderList from '@/components/OrderList'
import ActionList from './ActionList'
import { Amount, Button, ScrollView, ScrollViewMore } from 'mand-mobile'
import { homePage, listTradeRecord, totalityLimitAmount } from '@/api/home'
import formatTimestamp from '@/utils/format-timestamp'
import AcitvateResult from './AcitvateResult'
import HomeLayout from '@/layout/HomeLayout'
import fenToYuan from '@/utils/fen-to-yuan'
import { formatAmount } from '@/utils/format-amount'
const symbol = '--' // 金额为空时的符号

export default {
  name: 'Home',

  components: {
    OrderItem,
    OrderList,
    ActionList,
    [Amount.name]: Amount,
    [Button.name]: Button,
    [ScrollView.name]: ScrollView,
    [ScrollViewMore.name]: ScrollViewMore,
    AcitvateResult,
    HomeLayout
  },

  filters: {
    fenToYanAndFormat (num) {
      return formatAmount(fenToYuan(num))
    }
  },

  beforeRouteLeave (to, form, next) {
    this.autoReflow = false
    this.scrollTop = this.$refs.scrollView.getOffsets().top
    next()
  },

  data () {
    this.scrollTop = 0
    return {
      symbol,
      model: {
        balance: symbol
      },
      tradeList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      isShow: false,
      autoReflow: true,
      totalityLimitAmountData: {}
    }
  },

  computed: {
    isActive () {
      return this.$store.getters.isActive
    },
    faceAuditStatus () {
      return this.$store.getters.faceAuditStatus
    }
  },

  activated () {
    this.$nextTick(() => {
      this.$refs.scrollView.scrollTo(0, this.scrollTop, false)
      this.autoReflow = true
    })

    // 未激活 就不调用后续查询接口了
    if (!this.isActive) return

    homePage().then((result) => {
      this.model = result
    })
  },

  created () {
    // 激活后获取充值提转限额
    if (this.$route.params.level) {
      totalityLimitAmount().then((data) => {
        this.totalityLimitAmountData = data
        if (!this.faceAuditStatus) {
          // 不在人工审核时候展示弹窗
          this.isShow = true
        }
      })
    }

    if (!this.isActive) return

    this.getTradeList(this.pageNum, (result) => {
      this.tradeList = result.data
      this.total = result.total
    })
  },

  methods: {
    getTradeList (pageNum, callback) {
      const { pageSize } = this
      this.pageNum = pageNum
      listTradeRecord({
        pageNum,
        pageSize,
        tradeStartTime: formatTimestamp(new Date(), 'yyyy-MM')
      }).then(callback)
    },

    handleLoadMore () {
      if (this.tradeList.length >= this.total) return

      this.getTradeList(this.pageNum + 1, (result) => {
        this.tradeList = [...this.tradeList, ...result.data]
        this.total = result.total
        this.$refs.scrollView.finishLoadMore()
      })
    },

    handleToActivate () {
      this.$store.commit('change_agreementVisible', true)
    }
  }
}
</script>

<style scoped lang="scss">
.home-page {
  box-sizing: border-box;
  padding: 40px;
  position: relative;
  width: 100%;

  &::before {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    width: 100%;
    height: 308px;
    background: linear-gradient(180deg, #ffec00, #fff);
    z-index: 2;
  }
}

.activated-info {
  width: 100%;

  .md-button {
    height: 100px;
    font-size: 32px;
  }

  .title {
    font-size: 36px;
    margin-top: 0;
  }

  .sub-title {
    margin-bottom: 28px;
    color: #333;
    font-size: 28px;

    .sub-title-span {
      position: relative;
      bottom: 24px;
    }

    img {
      width: 100px;
      height: 100px;
    }
  }
}

.home-block {
  position: relative;
  z-index: 10;
  margin-bottom: 40px;
  padding: 60px 48px;
  border-radius: 16px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
  background:
    no-repeat
    url("../../assets/332fc4f1-cbad-4485-96f3-6fdf077d36c9.png");
  background-size: cover;
}

.amount-title {
  margin-bottom: 42px;
  font-size: 28px;
  color: #000;
  font-weight: normal;
}

.home-amount {
  display: block;
  margin-bottom: 50px;
  font-size: 80px;
  color: #333;

  &.large {
    font-size: 60px;
  }
}

.order-list-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 54px;
}

.mobile-top-up {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  padding: 36px 32px 38px 48px;
  border-radius: 32px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);

  .mobile-top-up-button {
    height: 72px;
    width: 270px;
    background: #fff;
    color: #bfb630;
    font-size: 28px;

    &::v-deep.md-button::after {
      border: 1px solid #bfb630;
      border-radius: 32px;
    }
  }

  .mobile-top-up-title {
    margin-bottom: 32px;
    font-size: 32px;
    color: #333;
  }

  .mobile-top-up-image {
    width: 220px;
    height: 186px;
    margin-left: 26px;
  }
}
</style>
